import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import '../../styles/Homepage.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Gallery Images - New concert images (most recent first)
import world39 from '../../assets/EditedFiles/world39.png';
import world38 from '../../assets/EditedFiles/world38.jpg';
import mariah from '../../assets/EditedFiles/Mariah.png';
import babymetal from '../../assets/EditedFiles/Babymetal.jpg';
import mayday from '../../assets/EditedFiles/MayDay.jpg';
import volleyball from '../../assets/EditedFiles/Volleyball.png';
import tylerthecreator from '../../assets/EditedFiles/Tylerthecreator.jpg';
import toto from '../../assets/EditedFiles/Toto.jpg';
import wanderland from '../../assets/EditedFiles/Wanderland.jpg';
import niki from '../../assets/EditedFiles/Niki.jpg';
import maroon5 from '../../assets/EditedFiles/Maroon5.jpg';
import cigs from '../../assets/EditedFiles/Cigs.jpg';
import stvincent from '../../assets/EditedFiles/St. Vincent.jpg';
import jasonderulo from '../../assets/EditedFiles/jason-derulo.jpg';

// Previous gallery images
import concert1 from '../../assets/EditedFiles/concert_rcs1.webp';
import concert2 from '../../assets/EditedFiles/concert_rcs2.webp';
import concert3 from '../../assets/EditedFiles/concert_rcs3.webp';
import concert4 from '../../assets/EditedFiles/concert_rcs4.webp';
import concert5 from '../../assets/EditedFiles/concert_rcs5.webp';
import concert6 from '../../assets/EditedFiles/concert_rcs6.webp';
import concert7 from '../../assets/EditedFiles/concert_rcs7.webp';
import concert8 from '../../assets/EditedFiles/concert_rcs8.webp';
import carnet1 from '../../assets/EditedFiles/carnet1.webp';
import carnet2 from '../../assets/EditedFiles/carnet2.webp';
import carnet3 from '../../assets/EditedFiles/carnet3.webp';
import cargo1 from '../../assets/EditedFiles/cargo1.webp';
import cargo2 from '../../assets/EditedFiles/cargo2.webp';
import cargo3 from '../../assets/EditedFiles/cargo3.webp';
import cargo4 from '../../assets/EditedFiles/cargo4.webp';
import cargo5 from '../../assets/EditedFiles/cargo5.webp';
import project1 from '../../assets/EditedFiles/project1.webp';
import project2 from '../../assets/EditedFiles/project2.webp';
import project3 from '../../assets/EditedFiles/project3.webp';
import project4 from '../../assets/EditedFiles/project4.webp';

const GalleryPreview = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Gallery images array (diversified mix of all categories)
  const galleryImages = [
    { src: world39, category: 'World Tours' },
    { src: world38, category: 'World Tours' },
    { src: cargo1, category: 'Project Cargo' },
    { src: jasonderulo, category: 'World Tours' },
    { src: mariah, category: 'World Tours' },
    { src: carnet1, category: 'Pandemic Response' },
    { src: babymetal, category: 'World Tours' },
    { src: project1, category: 'Project Cargo' },
    { src: mayday, category: 'World Tours' },
    { src: cargo2, category: 'Project Cargo' },
    { src: carnet2, category: 'Pandemic Response' },
    { src: volleyball, category: 'Sports Events' },
    { src: project2, category: 'Project Cargo' },
    { src: tylerthecreator, category: 'World Tours' },
    { src: cargo3, category: 'Project Cargo' },
    { src: toto, category: 'World Tours' },
    { src: carnet3, category: 'Pandemic Response' },
    { src: wanderland, category: 'World Tours' },
    { src: project3, category: 'Project Cargo' },
    { src: niki, category: 'World Tours' },
    { src: cargo4, category: 'Project Cargo' },
    { src: maroon5, category: 'World Tours' },
    { src: project4, category: 'Project Cargo' },
    { src: cigs, category: 'World Tours' },
    { src: cargo5, category: 'Project Cargo' },
    { src: stvincent, category: 'World Tours' },
    { src: concert1, category: 'World Tours' },
    { src: concert2, category: 'World Tours' },
    { src: concert3, category: 'World Tours' },
    { src: concert4, category: 'World Tours' },
    { src: concert5, category: 'World Tours' },
    { src: concert6, category: 'World Tours' },
    { src: concert7, category: 'World Tours' },
    { src: concert8, category: 'World Tours' }
  ];

  // Duplicate images for infinite scroll
  const duplicateImages = () => {
    return [...galleryImages, ...galleryImages];
  };

  // Slick carousel settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 15000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    swipeToSlide: false,
    touchMove: false,
    draggable: false,
    useCSS: true,
    useTransform: true,
    arrows: false,
    accessibility: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          speed: 15000,
          pauseOnHover: false,
          pauseOnFocus: false,
          swipeToSlide: false,
          touchMove: false,
          draggable: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          speed: 15000,
          pauseOnHover: false,
          pauseOnFocus: false,
          swipeToSlide: false,
          touchMove: false,
          draggable: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          speed: 15000,
          pauseOnHover: false,
          pauseOnFocus: false,
          swipeToSlide: false,
          touchMove: false,
          draggable: false,
        },
      },
    ],
  };

  return (
    <section className="gallery-preview-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">OUR WORK</div>
          <h2 className="section-title">Gallery</h2>
          <p className="section-description">
            Explore our successful logistics operations and see how we deliver excellence.
          </p>
        </div>

        {/* Gallery Infinite Carousel */}
        <div className="gallery-carousel-container" style={{ margin: '0 -15px' }}>
          {isMobile ? (
            // Mobile: Use Swiper for better performance
            <Swiper
              modules={[Autoplay]}
              spaceBetween={16}
              slidesPerView={1.2}
              centeredSlides={false}
              loop={true}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              speed={12000}
              allowTouchMove={false}
              breakpoints={{
                480: {
                  slidesPerView: 1.5,
                },
                640: {
                  slidesPerView: 2,
                },
              }}
              style={{ padding: '0 8px' }}
            >
              {galleryImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <div className="gallery-preview-item homepage-gallery-item" style={{ 
                    height: '320px', 
                    width: '100%',
                    position: 'relative',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: '2px solid transparent'
                  }}>
                    <img 
                      src={img.src} 
                      alt={`${img.category} project ${index + 1}`}
                      className="gallery-preview-image"
                      style={{ 
                        height: '320px', 
                        width: '100%',
                        objectFit: 'cover',
                        display: 'block'
                      }}
                    />
                    {/* Category Badge */}
                    <div 
                      className="category-badge"
                      style={{
                        position: 'absolute',
                        top: '12px',
                        left: '12px',
                        backgroundColor: 'rgba(27, 78, 114, 0.9)',
                        color: '#ffffff',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '11px',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      {img.category}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            // Desktop: Use Slick with hover effects
            <Slider {...sliderSettings}>
              {duplicateImages().map((img, index) => (
                <div key={index} className="gallery-carousel-item" style={{ padding: '0 8px', height: '320px' }}>
                  <div className="gallery-preview-item homepage-gallery-item" style={{ 
                    height: '320px', 
                    width: '100%',
                    cursor: 'pointer',
                    position: 'relative',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    border: '2px solid transparent'
                  }}>
                    <img 
                      src={img.src} 
                      alt={`${img.category} project ${index + 1}`}
                      className="gallery-preview-image"
                      style={{ 
                        height: '320px', 
                        width: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        transition: 'transform 0.3s ease'
                      }}
                    />
                    {/* Hover Overlay */}
                    <div className="gallery-overlay">
                      <div className="overlay-content">
                        <h3 className="overlay-title">{img.category}</h3>
                      </div>
                    </div>
                    {/* Category Badge */}
                    <div 
                      className="category-badge"
                      style={{
                        position: 'absolute',
                        top: '12px',
                        left: '12px',
                        backgroundColor: 'rgba(27, 78, 114, 0.9)',
                        color: '#ffffff',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '11px',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        cursor: 'default'
                      }}
                    >
                      {img.category}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </div>

        <div className="text-center mt-3">
          <a href="/gallery" className="btn-primary-hero">View Full Gallery</a>
        </div>
      </div>
    </section>
  );
};

export default GalleryPreview;
